let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3blSL")).then(() => parcelRequire('2wduP'));